<template>
  <VApp id="app" data-app="true">
    <RouterView
      :key="refreshKey"
    />
    <DebugOverlay/>
  </VApp>
</template>

<script>
import { mapGetters } from 'vuex'
import DebugOverlay from './components/debug/DebugOverlay.vue'
import LocaleMixin from './mixins/LocaleMixin'


const mixins = [
  LocaleMixin
]

export default {
  name: 'App',
  components: {
    DebugOverlay,
  },
  mixins,
  data () {
    return {
      refreshKey: Date.now()
    }
  },
  computed: {
    ...mapGetters({
      user: 'Auth/getUser'
    })
  },
  watch: {
    'user.id' (val, oldVal) {
      if (val !== oldVal) return
      this.refreshKey = Date.now()
    }
  },
  mounted () {
  }
}
</script>

<style>
</style>
